import DirectDepositInfo from './DirectDepositInfo'

export default DirectDepositInfo
